export default {
  title: 'Account instellingen',
  changeAvatar: 'Verander profielfoto',
  information: 'Informatie',
};
